import { useEffect, useState,useContext } from "react";
import Map, { Marker } from "react-map-gl";
import "mapbox-gl/dist/mapbox-gl.css";
import MarkerCustom from "./Marker/MarkerCustom";
import { MapContext } from "../../../contexts";
import { useStoreContext } from "../../../hooks/useStoreContext";

function MapBoxGl({ showLive, setShowLive }) {
  // eslint-disable-next-line
  const {setWareCode,zoom, setZoom} = useContext(MapContext)
  const [dataStore, dispatch] = useStoreContext();
  const [listWareHouse, setListWareHouse] = useState();
 
  const [viewport, setViewport] = useState({
    latitude: 16.05564,
    longitude: 104.208187,
  });
  const token =
    "pk.eyJ1IjoiY2h1bmd2cSIsImEiOiJjbGNzeHNuYWIwZmdlM29zMXp0emw0ZHIyIn0.qrkqLsQwQIkplAoGRYgWrQ";
  useEffect(() => {
    const maxLATITUDE = dataStore.listWareHouse.map((item) => {
      return item.LATITUDE;
    });
    const minValue = Math.min(...maxLATITUDE);
    const maxValue = Math.max(...maxLATITUDE);
    if (dataStore.listWareHouse.length > 0) {
      setListWareHouse(dataStore.listWareHouse);
      if (!dataStore.viewPort) {
        setViewport({
          latitude: (minValue+maxValue)/2,
          longitude: dataStore.listWareHouse[0].LONGITUDE-1.5,
        });
      } else {
        setViewport({
          latitude: dataStore.viewPort.LATITUDE,
          longitude: dataStore.viewPort.LONGITUDE,
        });
      }
    }
  }, [dataStore.listWareHouse, dataStore.viewPort]);
  const handleZoom = (data) => {
    setZoom(data.viewState.zoom);
  };
  const handleClickMarker = (latitude, longitude) => {
    setViewport({
      latitude: latitude,
      longitude: longitude,
    });
  };
  return (
    <Map
      {...viewport}
      mapStyle="mapbox://styles/mapbox/streets-v12"
      mapboxAccessToken={token}
      scrollZoom={true}
      zoom={zoom}
      onZoom={(view) => handleZoom(view)}
      minZoom={5}
      onMove={(e) => {
        setViewport(e.viewState);
      }}
      // scrollZoom
    >
      {listWareHouse &&
        listWareHouse.map((item, index) => {
          return (
            <Marker
              key={index}
              latitude={item.LATITUDE}
              longitude={item.LONGITUDE}
              onClick={(e) => handleClickMarker(item.LATITUDE, item.LONGITUDE)}
              style={{ zIndex: "1" }}
              draggable={true}
            >
              <MarkerCustom
                address={
                  item.COMMUNE_NAME +
                  "-" +
                  item.DISTRICT_NAME +
                  "-" +
                  item.PROVINCE_NAME
                }
                name={item.WAREHOUSE_NAME}
                indexLocation={item.INDEX_LOCATION}
                indexWareHouse={item.WAREHOUSE_CODE}
                latitude={item.LATITUDE}
                longitude={item.LONGITUDE}
                showLive={showLive}
                setShowLive={setShowLive}
              />
            </Marker>
          );
        })}
    </Map>
  );
}

export default MapBoxGl;
